import { render, staticRenderFns } from "./ComponentEditor.vue?vue&type=template&id=bd213b90&"
import script from "./ComponentEditor.vue?vue&type=script&lang=js&"
export * from "./ComponentEditor.vue?vue&type=script&lang=js&"
import style0 from "./ComponentEditor.vue?vue&type=style&index=0&id=bd213b90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports